import {Box} from "@mui/material";
import {SurveyStatus} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";
import {useTranslation} from "react-i18next";
import {ElementChip} from "./base/ElementChip";
import {getSurveyStatusColor} from "./colors";

export const SURVEY_STATUS_LABEL_KEYS: Record<SurveyStatus, string> = {
    [SurveyStatus.PUBLISHED]: 'Published',
    [SurveyStatus.DRAFT]: 'Draft',
};

interface SurveyStatusElementProps {
    status: SurveyStatus | undefined;
    asPrint?: boolean;
}

export function SurveyStatusElement({status, asPrint = false}: SurveyStatusElementProps) {
    const {t} = useTranslation();

    if (!status) {
        return null;
    }

    const text = t(SURVEY_STATUS_LABEL_KEYS[status] ?? status);

    if (asPrint) {
        return <>{text}</>;
    }

    return (
        <Box sx={{display: "inline-flex", maxWidth: "100%"}}>
            <ElementChip
                text={text}
                startIcon={
                    <Box
                        component="span"
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: getSurveyStatusColor(status),
                            flex: "0 0 auto",
                        }}
                    />
                }
            />
        </Box>
    );
}
